import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import ReactPocCard from './components/ReactPocCard';
import StudioSpotsCard from './components/StudioSpotsCard';

export type WebReactRegistry = {
  ReactPocCard?: typeof ReactPocCard;
  StudioSpotsCard?: typeof StudioSpotsCard;
  __React?: typeof React;
  __ReactDOM?: typeof ReactDOMClient;
};

export type WebReactWindow = Omit<Window, 'WebReactComponents'> & {
  WebReactComponents?: WebReactRegistry;
};

function registerGlobals() {
  if (typeof window === 'undefined') {
    return;
  }

  const webWindow = window as WebReactWindow;
  const registry: WebReactRegistry = webWindow.WebReactComponents ?? {};
  webWindow.WebReactComponents = registry;
  registry.ReactPocCard = ReactPocCard;
  registry.StudioSpotsCard = StudioSpotsCard;
  registry.__React = React;
  registry.__ReactDOM = ReactDOMClient;
}

registerGlobals();

export { ReactPocCard, StudioSpotsCard };
